import { iApplyFormControl, isControlWithValidators, isValueControl } from "app/shared/model";

export interface FindControlFn
{
    (control: iApplyFormControl): boolean
}

export interface ValidateControlFn
{
    (control: iApplyFormControl, fullControlName: string, controlValue: any, errors: ControlErrors): void
}

export type ValidationResult = {
    success: boolean;
    valid: boolean;
    firstPage?: { pageId: number | null, subpage?: number | null, subPageId?: number | null };
    errors?: ControlErrors;
}

export type ControlErrors = {
    [controlName: string]: string[];
}

export function mergeControlErrors(errors1: ControlErrors, errors2: ControlErrors): ControlErrors {
    let result = { ...errors1 };
    Object.keys(errors2).forEach(key => {
        if (Object.hasOwn(result, key)) {
            result[key] = [...new Set([...result[key], ...errors2[key]])]; // Concatenate arrays - no duplicates
        } else {
            result[key] = errors2[key];
        }
    });

    return result;
}

export function isEmptyInputValue(value: any)
{
    /**
     * Check if the object is a string or array before evaluating the length attribute.
     * This avoids falsely rejecting objects that contain a custom length attribute.
     * For example, the object {id: 1, length: 0, width: 0} should not be returned as empty.
     */
    return value == null ||
        ((typeof value === 'string' || Array.isArray(value)) && value.length === 0);
}

export class ValidationHelpers
{
    public static isMandatory(control: iApplyFormControl): boolean
    {
        return isValueControl(control) && control.mandatory === true;
    }

    public static hasValidators(control: iApplyFormControl): boolean
    {
        return isValueControl(control) &&
        isControlWithValidators(control) &&
        control.validators.length > 0;
    }

    public static isDatepicker(control: iApplyFormControl): boolean
    {
        return control.type === 'datepicker';
    }
}

export const focusOnErrorControl = (controlName: string) => {
    let validTags = ['SELECT', 'INPUT', 'TEXTAREA'];
    let input = document.querySelector('#' + controlName) as HTMLElement;

    if (!input || !input.tagName || !validTags.includes(input.tagName)) {
        input = document.querySelector(
            '#' + controlName + '0',
        ) as HTMLElement;
    }

    if (!input || !input.tagName || !validTags.includes(input.tagName)) {
        return false;
    }

    input.focus();
}
